import React from "react";
import i18n from "i18next";
import Scene3DBox from "./Scene3DBox";

/**
 * Scene3D plugin — shows an interactive 3D object authored by the backend's
 * Scene Visual Lab ("Görsel Ekle" → 3B Obje).
 *
 * The document in `state.htmlUrl` is self-contained: the model wrote its own
 * geometry, shading and the handles that turn it, and it paints every pixel
 * including its background. So there is no toolbar and nothing to edit element
 * by element — changes go back through the regenerate path, which writes a new
 * document and swaps the url.
 *
 * The sibling of MotionScene, with the one difference that matters: a motion
 * scene is driven by the playhead and has a duration, while a 3D object has
 * neither. It is a thing the learner turns, whenever they like.
 *
 * POINTER EVENTS — the one real conflict, resolved in Scene3DBox:
 *   • visor  → always on. Turning the object IS the feature.
 *   • editor → off by default, so the BOX can be selected, dragged and
 *     resized; an iframe that swallowed the mouse would make the box
 *     untouchable. A "Çevir" switch on the selected box turns them on when
 *     the author wants to handle the object itself.
 *
 * Why not the Webpage plugin, which also iframes a url: it is not registered
 * in this build's pluginList (core/config.es6), and turning it on would hand
 * every author a general-purpose "embed any URL" box — a product decision,
 * not a side effect of shipping this feature.
 */
export function Scene3D(base) {
  return {
    getConfig() {
      return {
        name: "Scene3D",
        displayName: i18n.t("Scene3D.PluginName", { defaultValue: "3B Obje" }),
        category: "media",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        // An object sits inside a scene that usually also carries text, so it
        // does not claim the whole frame the way a motion scene does.
        initialWidth: "60%",
        initialHeight: "70%",
        initialWidthSlide: "60%",
        initialHeightSlide: "70%",
        icon: "view_in_ar",
      };
    },

    getToolbar() {
      // Content is generated server-side; there is no per-element editing.
      return { main: { __name: "Scene3D", accordions: {} } };
    },

    getInitialState() {
      return {
        htmlUrl: "",
        label: "",
        model: "",
      };
    },

    getRenderTemplate(state, props) {
      const safeProps = props || {};
      const boxId = safeProps.id || null;
      return (
        <Scene3DBox
          state={state}
          boxId={boxId}
          visor={safeProps.visor === true}
          selected={!!boxId && safeProps.boxSelected === boxId}
        />
      );
    },
  };
}
